import React from "react";
import { Badge } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faClock,
  faExclamationTriangle,
  faMinusCircle,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";

/**
 * The audit track is independent of the release/PV status, so it gets its own
 * badge. Same component on the audit dashboards and on the release/PV pages the
 * pipeline uses, so a flag looks identical wherever it shows up.
 */
const VARIANTS = {
  "Not Audited": { bg: "secondary", icon: faMinusCircle, label: "Not audited" },
  "Pending AG Review": { bg: "warning", icon: faClock, label: "Pending AG review" },
  "AG Approved": { bg: "info", icon: faCheckCircle, label: "Approved by AG" },
  "AG Flagged": { bg: "danger", icon: faExclamationTriangle, label: "Flagged by AG" },
  "Audit Approved": { bg: "success", icon: faShieldAlt, label: "Audit approved" },
  "Audit Flagged": { bg: "danger", icon: faExclamationTriangle, label: "Flagged by audit" },
};

const AuditStatusBadge = ({ status, className = "" }) => {
  const variant = VARIANTS[status] || {
    bg: "secondary",
    icon: faMinusCircle,
    label: status || "Not audited",
  };

  return (
    <Badge bg={variant.bg} className={`audit-status-badge ${className}`.trim()}>
      <FontAwesomeIcon icon={variant.icon} className="me-1" />
      {variant.label}
    </Badge>
  );
};

export default AuditStatusBadge;
